// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Us34","tabsBox":"styles_tabsBox__1bT3I","createButton":"styles_createButton__36TN6"};